var map = {
	"./PHOTO-2024-08-18-21-01-12.jpg": 3782,
	"./PHOTO-2024-08-18-21-01-14 2.jpg": 1034,
	"./PHOTO-2024-08-18-21-01-15.jpg": 653,
	"./PHOTO-2024-08-18-21-01-16 2.jpg": 6952,
	"./PHOTO-2024-08-18-21-01-16.jpg": 1698,
	"./PHOTO-2024-08-18-21-01-17.jpg": 8079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8771;